import { roundOff } from "src/utils/helperFunctions";

/** Overview, then each bucket with a drill-down, as the tabs and the steps name them. */
export const sectionsOf = (buckets = []) => [
  { id: null, name: "Overview" },
  ...buckets.map((bucket) => ({
    id: bucket.id,
    name: bucket.displayName || bucket.name,
    score: bucket.score?.score,
  })),
];

/**
 * The report's sections as tabs, docked at the top of the report while it
 * scrolls: the one open in the accent with a bar under it.
 */
export const SectionTabs = ({ sections, activeId, onSelect }) => (
  <div className="r4-sections">
    <nav className="r4-tabs" aria-label="Sections of the report">
      {sections.map(({ id, name, score }) => {
        const on = (activeId ?? null) === id;
        return (
          <button
            key={id ?? "overview"}
            type="button"
            className={`r4-tab${on ? " r4-tab--on" : ""}`}
            aria-current={on ? "page" : undefined}
            onClick={() => onSelect(id)}
          >
            {name}
            {score != null && <span className="r4-tab__count">{roundOff(score)}</span>}
          </button>
        );
      })}
    </nav>
  </div>
);

/** The section before and after this one, at a section's foot, so reading on needs no trip to the top. */
export const SectionSteps = ({ sections, activeId, onSelect }) => {
  const at = sections.findIndex(({ id }) => id === activeId);
  if (at < 0) return null;
  const prev = sections[at - 1];
  const next = sections[at + 1];
  return (
    <nav className="r4-steps" aria-label="Other sections">
      {prev ? (
        <button type="button" className="r4-step" onClick={() => onSelect(prev.id)}>
          <span>← Previous</span>
          <b>{prev.name}</b>
        </button>
      ) : <span />}
      {next && (
        <button type="button" className="r4-step r4-step--next" onClick={() => onSelect(next.id)}>
          <span>Next →</span>
          <b>{next.name}</b>
        </button>
      )}
    </nav>
  );
};
